module.exports = __webpack_public_path__ + "static/media/scooter.6d7d3b22.jpg";